import React from 'react';
import MetricInfoPopover, { type MetricInfoDefinition } from '../ui/MetricInfoPopover';
import { opsChartCard } from '../operations/operationsUi';

type InsightsChartCardProps = {
  title: string;
  info?: MetricInfoDefinition;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  heightClass?: string;
};

export const INSIGHTS_CHART_TOOLTIP = {
  backgroundColor: '#111827',
  border: '1px solid #374151',
  borderRadius: '12px',
  fontSize: '12px',
  color: '#f9fafb',
};

const InsightsChartCard: React.FC<InsightsChartCardProps> = ({
  title,
  info,
  actions,
  children,
  className = '',
  heightClass = 'h-56',
}) => (
  <div className={`${opsChartCard} ${className}`}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        <p className="text-sm font-semibold text-gray-900 dark:text-white">{title}</p>
        {info && <MetricInfoPopover title={title} info={info} />}
      </div>
      {actions}
    </div>
    <div className={heightClass}>{children}</div>
  </div>
);

export default InsightsChartCard;
